module.exports = "/_next/static/images/ea1147e4bbdc12f9f5c3707c1f654305-credit-card-limit@1x.png.webp";